import React from 'react';
import { Form, Row, Col } from 'react-bootstrap';

var TabPropostaTitulos = function (_ref) {
  var parametros = _ref.parametros;
  var onChange = _ref.onChange;

  var p = parametros || {};

  var handleChange = function (campo, valor) {
    onChange(Object.assign({}, p, { [campo]: valor }));
  };

  return (
    <div>
      <Row>
        <Col md={4}>
          <Form.Group>
            <Form.Label>Conta Bx. Títulos Cancelados</Form.Label>
            <Form.Control
              type="number"
              value={p.conta_bx_can || ''}
              onChange={function (e) { handleChange('conta_bx_can', e.target.value); }}
            />
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group>
            <Form.Label>Portador MO. Aguardando Baixado</Form.Label>
            <Form.Control
              type="number"
              value={p.portador_mo_aguarda_bx || ''}
              onChange={function (e) { handleChange('portador_mo_aguarda_bx', e.target.value); }}
            />
          </Form.Group>
        </Col>
      </Row>
    </div>
  );
};

export default TabPropostaTitulos;
